// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","container__footer":"footer_container__footer__6GT1o","footer":"footer_footer__NjMd5"};